import { API_URL } from '../config/api';

export interface CarouselTemplate {
  id: string;
  name: string;
  isGlobal: boolean;
  htmlJson: string;
  createdAt: string;
}

export interface CreateCarouselTemplateRequest {
  name: string;
  htmlJson: string;
}

const api = {
  get: async (endpoint: string) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
      }
    });

    if (!response.ok) {
      throw new Error(`API request failed: ${response.statusText}`);
    }

    return response.json();
  },

  post: async (endpoint: string, data: any) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error(`API request failed: ${response.statusText}`);
    }

    return response.json();
  },

  delete: async (endpoint: string) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
      }
    });

    if (!response.ok) {
      throw new Error(`API request failed: ${response.statusText}`);
    }

    return response.status === 204 ? true : response.json();
  }
};

export const carouselTemplateService = {
  getTemplates: async (): Promise<CarouselTemplate[]> => {
    return api.get('/carousel-templates');
  },

  saveTemplate: async (data: CreateCarouselTemplateRequest): Promise<CarouselTemplate> => {
    return api.post('/carousel-templates', data);
  },

  deleteTemplate: async (id: string): Promise<boolean> => {
    return api.delete(`/carousel-templates/${id}`);
  }
};



